export class BulkPaymentReport{

    static readonly configDomain = {
        displayKey: "domainName",
        search: true,
        height: 'auto',
        placeholder: 'Select Domain',
        customComparator: () => { },
        noResultsFound: 'No results found!',
        clearOnSelection: true,
        searchOnKey: 'domainName'
    };

    static readonly satusList =[{key: "ALL", value: "All"},
                {key: "DONE", value: "Done"},
                {key: "IN_PROGRESS", value: "In Progress"},
                {key: "PENDING", value: "Pending"}]
}

export class commonDropdownConfig{
    langType = localStorage.getItem('lang');
    langSource = JSON.parse(localStorage.getItem('langSource'));
    //commision component 
    configOrgType = {
        limitTo: 50,
        displayKey:"orgName",
        search:true,
        height: 'auto',
        searchPlaceholder: this.langSource.search,
        placeholder:this.langSource.select,
        customComparator: ()=>{},
        noResultsFound: this.langSource.noResultsFound,
        clearOnSelection: true,
        searchOnKey: 'orgName'
    }; 
    configOrgTypePaymentReport = {
        limitTo: 50,
        displayKey:"orgName",
        search:true, 
        height: 'auto', 
        searchPlaceholder: this.langSource.search,
        placeholder:this.langSource.all,              
        customComparator: ()=>{},
        noResultsFound: this.langSource.noResultsFound,
        clearOnSelection: true,
        searchOnKey: 'orgName'
      };
    configDomain = {
        limitTo: 50,
        displayKey:"domainName",
        search:true, 
        height: 'auto', 
        searchPlaceholder: this.langSource.search,
        placeholder:this.langSource.select,              
        customComparator: ()=>{},
        noResultsFound: this.langSource.noResultsFound,
        clearOnSelection: true,
        searchOnKey: 'domainName'
    };
    // define set component
    dropdownSettings = {
        enableCheckAll: false,
        text: this.langSource.select, 
        primaryKey: 'txnTypeCode',
        labelKey: 'txnTypeName',
        selectAllText: this.langSource.selectAll,
        unSelectAllText: this.langSource.unSelectAll,
        itemsShowLimit: 10,
        allowSearchFilter: false,
        classes: "myclass custom-class",
        // lazyLoading: true,
        groupBy: 'category',
        selectGroup: true,
      };
    
      dropdownServiceSettings = {
        text: this.langSource.select, 
        primaryKey: 'serviceCode',
        labelKey: 'serviceDisplayName',
        selectAllText: this.langSource.selectAll,
        unSelectAllText: this.langSource.unSelectAll,
        itemsShowLimit: 10,
        allowSearchFilter: false,
        classes: "myclass custom-class",
        // lazyLoading: true,
      };
    
      dropdownGamesSettings = {
        text: this.langSource.select, 
        primaryKey: 'gameId',
        labelKey: 'gameName',
        selectAllText: this.langSource.selectAll,
        unSelectAllText: this.langSource.unSelectAll,
        itemsShowLimit: 10,
        allowSearchFilter: false,
        classes: "myclass custom-class",
        // lazyLoading: true,
      };
      configStatus = {
        displayKey: "value",
        search: true,
        height: 'auto',
        searchPlaceholder: this.langSource.search,
        placeholder:this.langSource.select,    
        noResultsFound: this.langSource.noResultsFound,
        clearOnSelection: true,
        searchOnKey: 'key'
    };

    servingRegionconfig = {
      displayKey: "regionName",
      search: false,
      height: 'auto',
      placeholder: this.langSource.select,
      customComparator: () => { },
      limitTo: 20,
      noResultsFound: this.langSource.noResultsFound,
    };
}